export const LOGOUT_REASON_STORAGE_KEY = 'odinseye.auth.logoutReason';
export const SESSION_EXPIRED_REASON = 'session-expired';

export const markLogoutReason = (reason: string): void => {
  sessionStorage.setItem(LOGOUT_REASON_STORAGE_KEY, reason);
};

export const clearLogoutReason = (): void => {
  sessionStorage.removeItem(LOGOUT_REASON_STORAGE_KEY);
};

export const getMarketingSignInUrl = (explicitReason?: string): string => {
  const marketingUrl = process.env.REACT_APP_MARKETING_URL ?? 'https://odinseye.eu';
  const signInUrl = new URL('/sign-in', marketingUrl);
  const reason = explicitReason ?? sessionStorage.getItem(LOGOUT_REASON_STORAGE_KEY);

  if (reason) {
    signInUrl.searchParams.set('reason', reason);
  }

  return signInUrl.toString();
};
